import { Controller } from "@hotwired/stimulus"

// Динамический редактор пар «ключ-значение» для characteristics товара.
export default class extends Controller {
  static targets = ["list", "template"]

  addRow() {
    const fragment = this.templateTarget.content.cloneNode(true)
    this.listTarget.appendChild(fragment)
    const rows = this.listTarget.querySelectorAll(".props-editor-row")
    const lastRow = rows[rows.length - 1]
    const firstInput = lastRow?.querySelector("input")
    firstInput?.focus()
  }

  removeRow(event) {
    event.currentTarget.closest(".props-editor-row")?.remove()
  }
}
